export default "__VITE_ASSET__bf31c346__"